<template>
  <Page>
    <div class="resportList">
      <div>
        <!-- 顶部 -->
        <div class="headerTitle-top">
          <div class="picker-alls" @click="showDeptAreaPop = !showDeptAreaPop">{{queryParams.deptAreaName || "请选择区域"}}
            <div class="triangle_border_down"></div>
          </div>&nbsp;
          <div v-show="showDeptAreaPop">
            <van-popup v-model="showDeptAreaPop" position="bottom" :overlay="true">
              <van-picker
                show-toolbar
                v-model="queryParams.deptArea"
                :columns="deptAreaList"
                value-key="name"
                @confirm="deptAreaChange"
                @cancel="showDeptAreaPop = !showDeptAreaPop"
              />
            </van-popup>
          </div>
          <div class="picker-alls" @click="showDeptPop = !showDeptPop">{{queryParams.deptName || "请选择门店"}}
            <div class="triangle_border_down"></div>
          </div>
          <div v-show="showDeptPop">
            <van-popup v-model="showDeptPop" position="bottom" :overlay="true">
              <van-picker
                show-toolbar
                v-model="queryParams.deptId"
                :columns="deptList"
                value-key="deptName"
                @confirm="deptChange"
                @cancel="showDeptPop = !showDeptPop"
              />
            </van-popup>
          </div>
        </div>
        <div class="headerTitle-top">
          <div class="picker-alls">
            <div class="flex item1" @click="showDateTime1=!showDateTime1">
              <p class="item1 date-time black" v-if="queryParams.startDate">{{queryParams.startDate}}</p>
              <p class="item1 date-time" v-else>{{queryParams.startDate || "请选择激活开始日期"}}</p>
              <div slot="right-icon"  class="triangle_border_down" />
            </div>
            <van-popup v-model="showDateTime1" position="bottom">
              <van-datetime-picker
                type="date"
                v-model="defaultStartTime"
                @confirm="getFirstDate"
                @cancel="showDateTime1=!showDateTime1"
              />
            </van-popup>
          </div>-
          <div class="picker-alls">
            <div class="flex item1" @click="showDateTime2=!showDateTime2">
              <p class="item1 date-time black" v-if="queryParams.endDate">{{queryParams.endDate}}</p>
              <p class="item1 date-time" v-else>{{queryParams.endDate || "请选择激活结束日期"}}</p>
              <div slot="right-icon"  class="triangle_border_down" />
            </div>
            <van-popup v-model="showDateTime2" position="bottom">
              <van-datetime-picker
                type="date"
                v-model="defaultEndTime"
                @confirm="getEndDate"
                @cancel="showDateTime2=!showDateTime2"
              />
            </van-popup>
          </div>
        </div>
        <div class="div-query-area">
          <van-row gutter="6" type="flex" justify="space-between">
            <van-col span="12">
              <van-button plain type="danger" size="small" @click="event4Clear">清空</van-button>
            </van-col>
            <van-col span="12">
              <van-button type="danger" size="small" @click="queryReportData">查询</van-button>
            </van-col>
          </van-row>
        </div>
      </div>

      <div>
        <div class="headerTitle-top picker-report-choose">
          <div class="picker-alls" @click="showReportType = !showReportType">{{queryParams.reportTypeName || "请选择报表类型"}}
            <div class="triangle_border_down"></div>
          </div>
          <div v-show="showReportType">
            <van-popup v-model="showReportType" position="bottom" :overlay="true">
              <van-picker
                show-toolbar
                v-model="queryParams.reportType"
                :columns="reportTypeList"
                value-key="name"
                @confirm="reportTypeChange"
                @cancel="showReportType = !showReportType"
              />
            </van-popup>
          </div>
        </div>
      </div>

      <div class="panel-report-chart">
        <div id="level1-chart-container">

        </div>
        <div id="level2-chart-container" v-if="showLevel2Chart">

        </div>
      </div>

      <div class="panel-report-chart">
        <!--产品一级分类销售金额统计表-->
        <table class="table-report" v-if="queryParams.reportType == reportTypeMap.prodOneSortAmount && tableData.prodOneSale && tableData.prodOneSale.length > 0">
          <thead>
          <tr>
            <th>一级分类</th>
            <th v-for="item in tableData.prodOneSale">{{item.salesName || ""}}</th>
            <!--<th>合计</th>-->
          </tr>
          </thead>
          <tbody>
          <tr v-for="(prodItem,pindex) in (tableData.prodOneSale[0].list || [])">
            <td>{{prodItem.prodName}}</td>
            <td v-for="item in tableData.prodOneSale">{{item.list[pindex].amount > 0 ? $numeral(item.list[pindex].amount || 0).format('0,0.00') : ""}}</td>
          </tr>
          </tbody>
        </table>

        <!--产品二级分类销售金额统计表-->
        <table id="tb-prod-prodTwoSortAmount" class="table-report" v-if="queryParams.reportType == reportTypeMap.prodTwoSortAmount && tableData.prodTwoSale && tableData.prodTwoSale.length > 0">
          <thead>
          <tr>
            <th>二级分类</th>
            <th v-for="item in tableData.prodTwoSale">{{item.salesName || ""}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(prodItem,pindex) in (tableData.prodTwoSale[0].list || [])">
            <td>{{prodItem.prodName}}</td>
            <td v-for="item in tableData.prodTwoSale">{{item.list[pindex].amount > 0 ? $numeral(item.list[pindex].amount || 0).format('0,0.00') : ''}}</td>
          </tr>
          </tbody>
        </table>

        <!--产品一级二级分类销售数量统计表-->
        <table id="tb-prod-oneTwoSaleCnt" class="table-report" v-if="queryParams.reportType == reportTypeMap.prodOneTwoSale && tableData.prodOneTwoSaleCnt && tableData.prodOneTwoSaleCnt.length > 0">
          <thead>
          <tr>
            <th>产品分类</th>
            <th v-for="item in tableData.prodOneTwoSaleCnt">{{item.prodName || ""}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(prodItem,pindex) in (tableData.prodOneTwoSaleCnt[0].prod2ndList || [])">
            <td>{{prodItem.prodName}}</td>
            <td v-for="item in tableData.prodOneTwoSaleCnt">{{item.prod2ndList[pindex].quantity > 0 ? $numeral(item.prod2ndList[pindex].quantity || 0).format('0,0') : ""}}</td>
          </tr>
          </tbody>
        </table>

        <!--客户性别统计表-->
        <table id="tb-prod-custGender" class="table-report" v-if="queryParams.reportType == reportTypeMap.custSexCnt">
          <thead>
          <tr>
            <th>销售顾问</th>
            <th>男</th>
            <th>女</th>
            <th>合计</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in (tableData.custGender || [])">
            <td>{{item.salesName}}</td>
            <td>{{item.manCnt || ""}}</td>
            <td>{{item.womanCnt || ""}}</td>
            <td>{{(item.manCnt + item.womanCnt) || ""}}</td>
          </tr>
          </tbody>
        </table>

        <!--客户所在城市统计表-->
        <table id="tb-prod-custBelongCityCnt" class="table-report" v-if="queryParams.reportType == reportTypeMap.custBelongCityCnt && tableData.custCity.length > 0">
          <thead>
          <tr>
            <th>所属省份</th>
            <th v-for="item in (tableData.custCity || [])">{{item.userName}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(cityItem,cindex) in (tableData.custCity[0].listMap || [])">
            <td>{{cityItem.province}}</td>
            <td v-for="item in tableData.custCity">{{item.listMap[cindex].countNumber > 0 ? $numeral(item.listMap[cindex].countNumber).format('0,0') : ""}}</td>
          </tr>
          </tbody>
        </table>

        <!--客户摄影主题统计表-->
        <table id="tb-prod-custPhotography" class="table-report" v-if="queryParams.reportType == reportTypeMap.custPhotography && tableData.photoTheme.length > 0">
          <thead>
          <tr>
            <th>摄影主题</th>
            <th v-for="item in (tableData.photoTheme || [])">{{item.userName}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(cityItem,cindex) in (tableData.photoTheme[0].listMap || [])">
            <td>{{cityItem.shootingType}}</td>
            <td v-for="item in tableData.photoTheme">{{item.listMap[cindex].countNumber > 0 ? $numeral(item.listMap[cindex].countNumber).format('0,0') : ""}}</td>
          </tr>
          </tbody>
        </table>

        <!--客户意向课程统计表-->
        <table id="tb-prod-custAttendSortCnt" class="table-report" v-if="queryParams.reportType == reportTypeMap.custAttendSortCnt && tableData.custAttendSort.length > 0">
          <thead>
          <tr>
            <th>销售顾问</th>
            <th v-for="item in (tableData.custAttendSort || [])">{{item.classes}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(cityItem,cindex) in (tableData.custAttendSort[0].listMap || [])">
            <td>{{cityItem.userName}}</td>
            <td v-for="item in tableData.custAttendSort">{{item.listMap[cindex].countNumber > 0 ? $numeral(item.listMap[cindex].countNumber).format('0,0') : ""}}</td>
          </tr>
          </tbody>
        </table>

        <!--客户兴趣爱好统计表-->
        <table id="tb-prod-custInterestSortCnt" class="table-report" v-if="queryParams.reportType == reportTypeMap.custInterestSortCnt && tableData.custInterestSort.length > 0">
          <thead>
          <tr>
            <th>销售顾问</th>
            <th v-for="item in (tableData.custInterestSort || [])">{{item.userName}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(cityItem,cindex) in (tableData.custInterestSort[0].listMap || [])">
            <td>{{cityItem.hobby}}</td>
            <td v-for="item in tableData.custInterestSort">{{item.listMap[cindex].countNumber > 0 ? $numeral(item.listMap[cindex].countNumber).format('0,0') : ""}}</td>
          </tr>
          </tbody>
        </table>

      </div>

    </div>
  </Page>
</template>


<script>
  import echarts from 'echarts';
  import moment from 'moment';
  import $ from 'jquery';
  import jp from 'jsonpath';

  export default {
    data() {
      return {
        show:false,
        columns:[],
        queryParams : {
          startDate : null,
          endDate : null,
          startDateTS : null,
          endDateTS : null,
          deptArea : '',
          deptAreaName : '',
          deptId : '',
          deptName : '',
          reportType : '',
          reportTypeName : ''
        },
        reportTypeMap : { //报表类型
          prodOneTwoSale : "9", //产品一级二级分类销售统计表
          prodTwoSortAmount : "8", //产品二级分类销售金额统计表
          prodOneSortAmount : "7", //产品一级分类销售金额统计表
          custBelongCityCnt : "6",//客户所在城市分布人数统计表
          custInterestSortCnt : "5",//客户兴趣爱好分类统计表
          custPhotography : "4",//客户摄影主题分类统计表
          custAttendSortCnt : "3",//客户意向课程分类统计表,
          custSexCnt : "2" //客户性别统计表
        },
        defaultStartTime : new Date(),
        defaultEndTime : new Date(),
        loading: false,
        finished: false,
        totalRow: 100,
        active: 0,
        showDateTime1 : false,
        showDateTime2 : false,
        showDeptAreaPop : false, //显示区域选择
        showDeptPop : false, //显示部门选择,
        showReportType : false,//显示报表类型选择
        showLevel2Chart : false,//显示二级报表
        deptAreaList : [
          {
            name:'请选择区域',
            value:''
          }
        ], //区域列表
        deptList : [
          {
            deptName:'请选择门店',
            deptId:''
          }
        ], //部门列表
        reportTypeList : [
          {
            name:'请选择报表类型',
            value:''
          }
        ],//报表类型列表
        tableData : {
          prodOneTwoSaleCnt : [],//产品一级二级分类销售数量
          prodTwoSale : [],//产品二级分类销售金额表
          prodOneSale : [], //产品一级分类销售金额表
          custGender : [], //客户性别报表
          custCity : [],//客户所在城市报表
          photoTheme : [],//摄影主题报表
          custAttendSort : [],//客户意向课程统计表
          custInterestSort : []//客户兴趣爱好统计表
        },
        chartColor : ["#2f75b5","#ffe699","#548235","#c65911","#000000","#aeaaaa","#ff0000","#b4c6e7","#f4b084","#ffd966","#c6e0b4","#ffccff"], //表格色系 ['#c23531','#2f4554', '#61a0a8', '#d48265', '#91c7ae','#749f83',  '#ca8622', '#bda29a','#6e7074', '#546570', '#c4ccd3']
      };
    },
    watch : {
      "queryParams.reportType" :function (val,oldVal) {
        this.clearData();
      },
      "tableData.custAttendSort" : function (val,oldVal) {
          let that = this;
          setTimeout(function () {
            that.hideEmptyTr("tb-prod-oneTwoSaleCnt");
          },1000);
      },
      "tableData.prodOneTwoSaleCnt" : function (val,oldVal) {
        let that = this;
        setTimeout(function () {
          that.hideEmptyTr("tb-prod-prodTwoSortAmount");
        },1000);
      },
      "tableData.custCity" : function (val,oldVal) {
        let that = this;
        setTimeout(function () {
          that.hideEmptyTr("tb-prod-custBelongCityCnt");
        },1000);
      },
      "tableData.custGender" : function (val,oldVal) {
        let that = this;
        setTimeout(function () {
          that.hideEmptyTr("tb-prod-custGender");
        },1000);
      },
      "tableData.custInterestSort" : function (val,oldVal) {
        let that = this;
        setTimeout(function () {
          that.hideEmptyTr("tb-prod-custInterestSortCnt");
        },1000);
      },
      "tableData.photoTheme" : function (val,oldVal) {
        let that = this;
        setTimeout(function () {
          that.hideEmptyTr("tb-prod-custPhotography");
        },1000);
      }
    },
    methods: {
      /**
       * 计算X轴的合计
       */
      sumXAxis : function(list,key){
        list = list || [];
        let total = 0;
        for (let i = 0; i <list.length; i++) {
          let obj = list[i];
          let val = parseFloat(obj[key]) || 0;

          total += val;
        }
        return total;
      },

      /**
       * 隐藏空行
       */
      hideEmptyTr : function(tableId){
        $("#"+tableId+" tbody tr").each(function (i) {
          let that = $(this);
          let tdList = that.find("td:gt(0)");
          let hasContent = false;
          tdList.each(function (j) {
            let tdDom = $(this);
            if(tdDom.html()){
              hasContent = true;
            }
          });
          if(!hasContent){
            that.css({"display":"none"});
          }
        });
      },

      /**
       * 检查是否是所有的都为0
       */
      checkIsAllZero(list,key){
        list = list ||[];
        let flag = true;
        for (let i=0;i<list.length;i++){
          let obj = list[i];
          if(obj[key] && obj[key] > 0){
             flag = false;
             break;
          }
        }
        return flag;
      },

      /**
       * 获取一级图的DOM
       */
      getLevel1ChartDom(){
        return echarts.init($('#level1-chart-container')[0]);
      },

      /**
       * 获取二级图的DOM
       */
      getLevel2ChartDom(){
        var dom = $('#level2-chart-container')[0];
        if(!dom){
          return null;
        }
        return echarts.init(dom);
      },

      /**
       * 一级图形报表清空
       */
      clearLevel1ChartDom(){
        let level1ChartDom = this.getLevel1ChartDom();
        if(level1ChartDom){
          level1ChartDom.clear();
          level1ChartDom.dispose();
        }

      },

      /**
       * 二级图形报表清空
       */
      clearLevel2ChartDom(){
        let level2ChartDom = this.getLevel2ChartDom();
        if(level2ChartDom){
          level2ChartDom.clear();
          level2ChartDom.dispose();
        }
      },

      /**
       * 清除数据
       */
      clearData() {
        this.tableData = {
          prodOneTwoSaleCnt : [],//产品一级二级分类销售数量
            prodTwoSale : [],//产品二级分类销售金额表
            prodOneSale : [], //产品一级分类销售金额表
            custGender : [], //客户性别报表
            custCity : [],//客户所在城市报表
            photoTheme : [],//摄影主题报表
            custAttendSort : [],//客户意向课程统计表
            custInterestSort : []//客户兴趣爱好统计表
        };
        this.showLevel2Chart = false;

        $('#level1-chart-container').css({"min-height" : "6rem"});

        this.clearLevel1ChartDom();
        this.clearLevel2ChartDom();
      },

      /**
       * 清空事件
       */
      event4Clear(){
        this.clearData();
        this.queryParams = {
          startDate : null,
          endDate : null,
          startDateTS : null,
          endDateTS : null,
          deptArea : '',
          deptAreaName : '',
          deptId : '',
          deptName : '',
          reportType : '',
          reportTypeName : ''
        };
      },

      /**
       * 绘制产品一级分类销售金额饼图
       */
      drawProOneSalePie(pieData){
        var legendData = [];
        var seriesData = [];
        var selectedData = {};

        if(!pieData || pieData.length <= 0){
          return ;
        }
        for(let i=0;i<pieData.length;i++){
          let pieObj = pieData[i];
          let salesName = pieObj.salesName;

          legendData.push(salesName);
          seriesData.push({
            name : salesName,
            value : pieObj.amount,
            salesId : pieObj.salesId
          });
          selectedData[salesName] = pieObj.amount > 0;
        }

        var chartOption = {
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          color : this.chartColor,
          legend: {
            type: 'scroll',
//            orient: 'vertical',
//            right: 10,
//            top: 20,
            bottom: 0,
            left: 'center',
            data: legendData,
            selected: selectedData
          },
          series : [
            {
              name: '销售用户',
              type: 'pie',
              radius : '55%',
              center: ['40%', '50%'],
              data: seriesData,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        };
        let that = this;
        let chartDom = this.getLevel1ChartDom();
        chartDom.setOption(chartOption);
        chartDom.on("click",function (params) {
          let pieData = params.data || {};
          let salesId = pieData.salesId;
          that.showLevel2Chart = true;
          //触发柱状图生成
          that.drawProOneSaleLineChart(salesId);
        });
      },

      /**
       * 查询产品一级分类销售情况的条形图
       */
      drawProOneSaleLineChart(salesId){
        this.$api.get("api/prodReport/query1stByUserId",{
          dealerId : this.queryParams.deptId,
          salesId : this.$wxuserUtil.getUserId(),
          startDate : this.queryParams.startDate,
          endDate : this.queryParams.endDate,
          userId : salesId
        }).then(response => {
          if(response.success){
            let lineDataSource = response.data || [];
            let yAxisData = [];
            let series1Data = [];

            for(let i = 0;i<lineDataSource.length;i++){
              let lineDataObj = lineDataSource[i];
              yAxisData.push(lineDataObj.prodName);
              series1Data.push(lineDataObj.salesAmount);
            }

            let chartOption = {
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                }
              },
              color : this.chartColor,
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01]
              },
              yAxis: {
                type: 'category',
                data: yAxisData
              },
              series: [
                {
                  name: '产品一级分类',
                  type: 'bar',
                  data: series1Data
                }
              ]
            };

            let chartDom = this.getLevel2ChartDom();
            chartDom.clear();
            chartDom.setOption(chartOption);
          }
        });
      },

      /**
       * 绘制产品一级分类销售数量饼图
       */
      drawProOneSaleCntPie(pieData){
        var legendData = [];
        var seriesData = [];
        var selectedData = {};

        if(!pieData || pieData.length <= 0){
          return ;
        }
        for(let i=0;i<pieData.length;i++){
          let pieObj = pieData[i];
          let prodName = pieObj.prodName;

          legendData.push(prodName);
          seriesData.push({
            name : prodName,
            value : pieObj.quantity,
            prodName : prodName
          });
          selectedData[prodName] = pieObj.quantity > 0;
        }

        var chartOption = {
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          color : this.chartColor,
          legend: {
            type: 'scroll',
            bottom: 0,
            left: 'center',
            data: legendData,
            selected: selectedData
          },
          series : [
            {
              name: '产品一级分类',
              type: 'pie',
              radius : '55%',
              center: ['40%', '50%'],
              data: seriesData,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        };
        let that = this;
        let chartDom = this.getLevel1ChartDom();
        chartDom.setOption(chartOption);
        chartDom.on("click",function (params) {
          let pieData = params.data || {};
          let prodName = pieData.prodName;
          that.showLevel2Chart = true;
          //触发柱状图生成
          that.drawProTwoSaleCntLineChart(prodName);
        });
      },

      /**
       * 查询产品二级分类销售数量的条形图
       */
      drawProTwoSaleCntLineChart(prodName){
        this.$api.get("api/prodReport/query2ndListBy1st",{
          dealerId : this.queryParams.deptId,
          salesId : this.$wxuserUtil.getUserId(),
          startDate : this.queryParams.startDate,
          endDate : this.queryParams.endDate,
          products1stType : prodName
        }).then(response => {
          if(response.success){
            let lineDataSource = response.data || [];
            let yAxisData = [];
            let series1Data = [];

            for(let i = 0;i<lineDataSource.length;i++){
              let lineDataObj = lineDataSource[i];
              let quantity = lineDataObj.quantity;
              if(quantity <=0){
                continue;
              }

              yAxisData.push(lineDataObj.prodName);
              series1Data.push(lineDataObj.quantity);
            }

            let chartOption = {
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                }
              },
              color : this.chartColor,
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01]
              },
              yAxis: {
                type: 'category',
                data: yAxisData
              },
              series: [
                {
                  name: '产品二级分类',
                  type: 'bar',
                  data: series1Data
                }
              ]
            };

            let chartDom = this.getLevel2ChartDom();
            chartDom.clear();
            chartDom.setOption(chartOption);
          }
        });
      },

      /**查询产品一级二级分类销售数量统计表*/
      queryProdOneTwoSale(){
        this.$api.get("api/prodReport/query1stAnd2nd",{
          dealerId : this.queryParams.deptId,
          salesId : this.$wxuserUtil.getUserId(),
          startDate : this.queryParams.startDate,
          endDate : this.queryParams.endDate
        }).then(response => {
          if(response.success){
            //绘制饼图
            this.drawProOneSaleCntPie(response.data.pie || []);

            //绘制表格
            this.tableData.prodOneTwoSaleCnt = response.data.table || [];
          }else{
            this.$toast(response.msg || `报表数据查询失败`);
          }
        });
      },

      /**
       * 绘制产品二级分类销售金额饼图
       */
      drawProTwoSalePie(pieData){
        var legendData = [];
        var seriesData = [];
        var selectedData = {};

        if(!pieData || pieData.length <= 0){
          return ;
        }
        for(let i=0;i<pieData.length;i++){
          let pieObj = pieData[i];
          let salesName = pieObj.salesName;

          legendData.push(salesName);
          seriesData.push({
            name : salesName,
            value : pieObj.amount,
            salesId : pieObj.salesId
          });
          selectedData[salesName] = pieObj.amount > 0;
        }

        var chartOption = {
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          color : this.chartColor,
          legend: {
            type: 'scroll',
//            orient: 'vertical',
//            right: 10,
//            top: 20,
            bottom: 0,
            left: 'center',
            data: legendData,
            selected: selectedData
          },
          series : [
            {
              name: '销售用户',
              type: 'pie',
              radius : '55%',
              center: ['40%', '50%'],
              data: seriesData,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        };
        let that = this;
        let chartDom = this.getLevel1ChartDom();
        chartDom.setOption(chartOption);
        chartDom.on("click",function (params) {
          let pieData = params.data || {};
          let salesId = pieData.salesId;
          that.showLevel2Chart = true;
          //触发柱状图生成
          that.drawProdTwoSaleLineChart(salesId);
        });
      },

      /**
       * 查询产品一级分类销售情况的条形图
       */
      drawProdTwoSaleLineChart(salesId){
        this.$api.get("api/prodReport/query2ndByUserId",{
          dealerId : this.queryParams.deptId,
          salesId : this.$wxuserUtil.getUserId(),
          startDate : this.queryParams.startDate,
          endDate : this.queryParams.endDate,
          userId : salesId
        }).then(response => {
          if(response.success){
            let lineDataSource = response.data || [];
            let yAxisData = [];
            let series1Data = [];

            for(let i = 0;i<lineDataSource.length;i++){
              let lineDataObj = lineDataSource[i];
              let salesAmount = lineDataObj.salesAmount;
              if(salesAmount <= 0){
                continue;
              }

              yAxisData.push(lineDataObj.prodName);
              series1Data.push(salesAmount);
            }

            let chartOption = {
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                }
              },
              color : this.chartColor,
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01]
              },
              yAxis: {
                type: 'category',
                data: yAxisData
              },
              series: [
                {
                  name: '产品二级分类',
                  type: 'bar',
                  data: series1Data
                }
              ]
            };

            let chartDom = this.getLevel2ChartDom();
            chartDom.clear();
            chartDom.setOption(chartOption);
          }
        });
      },

      /**产品二级分类销售金额统计表*/
      queryProdTwoSortAmount(){
        this.$api.get("api/prodReport/query2nd",{
          dealerId : this.queryParams.deptId,
          salesId : this.$wxuserUtil.getUserId(),
          startDate : this.queryParams.startDate,
          endDate : this.queryParams.endDate
        }).then(response => {
          if(response.success){
            //绘制饼图
            this.drawProTwoSalePie(response.data.pie || []);

            //绘制表格
            this.tableData.prodTwoSale = response.data.table || [];
          }else{
            this.$toast(response.msg || `报表数据查询失败`);
          }
        });
      },

      /**
       * 产品一级分类销售金额统计表
       */
      queryProdOneSortAmount(){
        this.$api.get("api/prodReport/queryProd1st",{
          dealerId : this.queryParams.deptId,
          salesId : this.$wxuserUtil.getUserId(),
          startDate : this.queryParams.startDate,
          endDate : this.queryParams.endDate
        }).then(response => {
          if(response.success){
            //绘制饼图
            this.drawProOneSalePie(response.data.pie || []);

            //绘制表格
            this.tableData.prodOneSale = response.data.table || [];
          }else{
            this.$toast(response.msg || `报表数据查询失败`);
          }
        });
      },


      /**
       * 绘制客户所在城市条形图
       */
      drawCustBelongCityLine(reportDataList){
        if(!reportDataList || reportDataList.length <= 0){
          return ;
        }



        let label = {
          normal: {
            show: true,
            position: 'inside',
            formatter: function (params) {
              return params.value <= 0 ? '' : (params.value);
            }
          }
        };

        let legendData = [];
        let yAxisData = [];

        let seriesData = [];

        for(let i=0;i<reportDataList.length;i++){
          let reptObj = reportDataList[i];
          let userName = reptObj.userName;
          let provinceList = reptObj.listMap;

          legendData.push(userName);

          let seriesDataList = [];

          for(let j=0;j<provinceList.length;j++){
            let provinceObj = provinceList[j];
            let provinceId = provinceObj.provinceId;
            let countNumber = provinceObj.countNumber;

            let gt0List = jp.query({rept : reportDataList},`$..listMap[?(@.countNumber>0 && @.provinceId=='${provinceId}')]`) ||[];
            if(gt0List.length <= 0){
              continue;
            }

            seriesDataList.push(countNumber);
          }
          console.log("seriesDataList13",seriesDataList);
          seriesData.push({
            name: userName,
            type: 'bar',
            stack: '总量',
            label: label,
            /*itemStyle : {
              color : "#C0504D"
            },*/
            data: seriesDataList
          });
        }

        for(let i=0;i<reportDataList[0].listMap.length;i++){
          let reptObj = reportDataList[0].listMap[i];
          let provinceId = reptObj.provinceId;
          let province = reptObj.province;
          //没有大于0的就不显示到界面
          let gt0List = jp.query({rept : reportDataList},`$..listMap[?(@.countNumber>0 && @.provinceId=='${provinceId}')]`) ||[];
          if(gt0List.length <= 0){
            continue;
          }
          yAxisData.push(province);
        }

        if(yAxisData.length >= 10){
          $('#level1-chart-container').css({"min-height" : "10rem"});
        }else{
          $('#level1-chart-container').css({"min-height" : "6rem"});
        }

        let chartOption = {
          tooltip : {
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          color : this.chartColor,
          legend: {
            data: legendData,
            /* bottom: 0,
             left: 'center',*/
            type: 'scroll'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis:  {
            type: 'value'
          },
          yAxis: {
            type: 'category',
            data: yAxisData
          },
          series: seriesData
        };

        this.getLevel1ChartDom().setOption(chartOption);
      },

      /**
       * 客户所在城市分布人数统计表
       */
      queryCustBelongCityCnt(){
        this.$api.get("api/salesReport/provinceClassify",{
          dealerId : this.queryParams.deptId,
          salesId : this.$wxuserUtil.getUserId(),
          startDate : this.queryParams.startDate,
          endDate : this.queryParams.endDate
        }).then(response => {
          if(response.success){
            //绘制条形图
           this.drawCustBelongCityLine(response.data || []);

            //绘制表格
            this.tableData.custCity = response.data || [];
          }else{
            this.$toast(response.msg || `报表数据查询失败`);
          }
        });
      },

      /**
       * 绘制客户兴趣爱好条形图
       */
      drawCustInterestSortLine(reportDataList){
        if(!reportDataList || reportDataList.length <= 0){
          return ;
        }

        let label = {
          normal: {
            show: true,
            position: 'inside',
            formatter: function (params) {
              return params.value <= 0 ? '' : (params.value);
            }
          }
        };

        let legendData = [];
        let yAxisData = [];

        let seriesData = [];

        let hobbyList = reportDataList[0].listMap || [];
        for(let i=0;i<hobbyList.length;i++){
          let hobbyObj = hobbyList[i];
          let hobby = hobbyObj["hobby"];
          legendData.push(hobby);

          let seriesDataList = [];
          for(let j=0;j<reportDataList.length;j++){
            let salesObj = reportDataList[j];
            let gt0List = jp.query(salesObj,`$..listMap[?(@.countNumber>0)]`) ||[];
            if(gt0List.length <= 0){
              continue;
            }
            let countNumber = salesObj.listMap[i].countNumber;
            seriesDataList.push(countNumber);
          }
          console.log("seriesDataList",seriesDataList);
          seriesData.push({
            name: hobby,
            type: 'bar',
            stack: '总量',
            label: label,
            /*itemStyle : {
              color : "#C0504D"
            },*/
            data: seriesDataList
          });
        }

        for(let i=0;i<reportDataList.length;i++){
          let reptObj = reportDataList[i];
          let salesName = reptObj.userName;
          //没有大于0的就不显示到界面
          let gt0List = jp.query(reptObj,`$..listMap[?(@.countNumber>0)]`) ||[];
          if(gt0List.length <= 0){
            continue;
          }
          yAxisData.push(salesName);
        }

        let chartOption = {
          tooltip : {
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          color : this.chartColor,
          legend: {
            data: legendData,
           /* bottom: 0,
            left: 'center',*/
            type: 'scroll'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis:  {
            type: 'value'
          },
          yAxis: {
            type: 'category',
            data: yAxisData
          },
          series: seriesData
        };

        this.getLevel1ChartDom().setOption(chartOption);
      },

      /**
       * 客户兴趣爱好分类统计表
       */
      queryCustInterestSortCnt(){
        this.$api.get("api/salesReport/hobbyClassify",{
          dealerId : this.queryParams.deptId,
          salesId : this.$wxuserUtil.getUserId(),
          startDate : this.queryParams.startDate,
          endDate : this.queryParams.endDate
        }).then(response => {
          if(response.success){
            //条形图
            this.drawCustInterestSortLine(response.data || []);

            //绘制表格
            this.tableData.custInterestSort = response.data || [];
          }else{
            this.$toast(response.msg || `报表数据查询失败`);
          }
        });
      },

      /**
       * 绘制摄影主题分类条形图
       */
      drawCustPhotographyLine(reportDataList){
        if(!reportDataList || reportDataList.length <= 0){
          return ;
        }

        let label = {
          normal: {
            show: true,
            position: 'inside',
            formatter: function (params) {
              return params.value <= 0 ? '' : (params.value);
            }
          }
        };

        let legendData = [];
        let yAxisData = [];

        let seriesData = [];

        let shootingTypeList = reportDataList[0].listMap || [];
        for(let i=0;i<shootingTypeList.length;i++){
          let shootingTypeObj = shootingTypeList[i];
          let shootingType = shootingTypeObj["shootingType"];
          legendData.push(shootingType);

          let seriesDataList = [];
          for(let j=0;j<reportDataList.length;j++){
            let salesObj = reportDataList[j];
            let gt0List = jp.query(salesObj,`$..listMap[?(@.countNumber>0)]`) ||[];
            if(gt0List.length <= 0){
              continue;
            }
            let countNumber = salesObj.listMap[i].countNumber;
            seriesDataList.push(countNumber);
          }
          console.log("seriesDataList",seriesDataList);
          seriesData.push({
            name: shootingType,
            type: 'bar',
            stack: '总量',
            label: label,
            /*itemStyle : {
              color : "#C0504D"
            },*/
            data: seriesDataList
          });
        }

        for(let i=0;i<reportDataList.length;i++){
          let reptObj = reportDataList[i];
          let salesName = reptObj.userName;
          //没有大于0的就不显示到界面
          let gt0List = jp.query(reptObj,`$..listMap[?(@.countNumber>0)]`) ||[];
          if(gt0List.length <= 0){
            continue;
          }
          yAxisData.push(salesName);
        }

        let chartOption = {
          tooltip : {
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          color : this.chartColor,
          legend: {
            data: legendData,
            /* bottom: 0,
             left: 'center',*/
            type: 'scroll'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis:  {
            type: 'value'
          },
          yAxis: {
            type: 'category',
            data: yAxisData
          },
          series: seriesData
        };

        this.getLevel1ChartDom().setOption(chartOption);
      },

      /**
       * 客户摄影主题分类统计表
       */
      queryCustPhotography(){
        this.$api.get("api/salesReport/shootingTypeClassify",{
          dealerId : this.queryParams.deptId,
          salesId : this.$wxuserUtil.getUserId(),
          startDate : this.queryParams.startDate,
          endDate : this.queryParams.endDate
        }).then(response => {
          if(response.success){
            //绘制条形图
            this.drawCustPhotographyLine(response.data || []);

            //绘制表格
            this.tableData.photoTheme = response.data || [];
          }else{
            this.$toast(response.msg || `报表数据查询失败`);
          }
        });
      },

      /**
       * 绘制意向课程分类条形图
       */
      drawCustAttendSortLine(reportDataList){
        if(!reportDataList || reportDataList.length <= 0){
          return ;
        }

        let label = {
          normal: {
            show: true,
            position: 'inside',
            formatter: function (params) {
              return params.value <= 0 ? '' : (params.value);
            }
          }
        };

        let legendData = [];
        let yAxisData = [];

        let seriesData = [];

        let legendList = reportDataList || [];
        for(let i=0;i<legendList.length;i++){
          let legendObj = legendList[i];
          let legend = legendObj["classes"];
          legendData.push(legend);

          let seriesDataList = [];
          let subList = legendObj.listMap || [];
          for(let j=0;j<subList.length;j++){
            let salesObj = subList[j];
            let salesName = salesObj.userName;
            let gt0List = jp.query({report : reportDataList},`$..listMap[?(@.countNumber>0 && @.userName=='${salesName}')]`) ||[];
            if(gt0List.length <= 0){
              continue;
            }
            let countNumber = salesObj.countNumber;
            seriesDataList.push(countNumber);
          }
          console.log("seriesDataList",seriesDataList);
          seriesData.push({
            name: legend,
            type: 'bar',
            stack: '总量',
            label: label,
            /*itemStyle : {
              color : "#C0504D"
            },*/
            data: seriesDataList
          });
        }

        let subList = reportDataList[0].listMap || [];
        for(let i=0;i<subList.length;i++){
          let reptObj = subList[i];
          let salesName = reptObj.userName;
          //没有大于0的就不显示到界面
          let gt0List = jp.query({report : reportDataList},`$..listMap[?(@.countNumber>0 && @.userName=='${salesName}')]`) ||[];
          if(gt0List.length <= 0){
            continue;
          }
          yAxisData.push(salesName);
        }

        let chartOption = {
          tooltip : {
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          color : this.chartColor,
          legend: {
            data: legendData,
            /* bottom: 0,
             left: 'center',*/
            type: 'scroll'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis:  {
            type: 'value'
          },
          yAxis: {
            type: 'category',
            data: yAxisData
          },
          series: seriesData
        };

        this.getLevel1ChartDom().setOption(chartOption);
      },

      /**
       * 客户意向课程分类统计表
       */
      queryCustAttendSortCnt(){
        this.$api.get("api/salesReport/courseClassify",{
          dealerId : this.queryParams.deptId,
          salesId : this.$wxuserUtil.getUserId(),
          startDate : this.queryParams.startDate,
          endDate : this.queryParams.endDate
        }).then(response => {
          if(response.success){
            //绘制条形图
            this.drawCustAttendSortLine(response.data || []);

            //绘制表格
            this.tableData.custAttendSort = response.data || [];
          }else{
            this.$toast(response.msg || `报表数据查询失败`);
          }
        });
      },

      /**
       * 绘制客户性别图
       */
      drawCustSexLine(reportDataList){
        let legendData = ["男","女"];
        let yAxisData = [];
        let manCntList =[];
        let womanCntList = [];

        reportDataList = reportDataList || [];
        for(let i=0;i<reportDataList.length;i++){
          let reptObj = reportDataList[i];
          let salesName = reptObj.salesName;
          let manCnt = reptObj.manCnt || 0;
          let womanCnt = reptObj.womanCnt || 0;

          let totalCnt = manCnt + womanCnt;
          if(totalCnt <= 0){
            continue;
          }

          yAxisData.push(salesName);
          manCntList.push(manCnt);
          womanCntList.push(womanCnt);
//          manCntList.push((parseFloat(manCnt/totalCnt)*100).toFixed(2));
//          womanCntList.push((parseFloat(womanCnt/totalCnt)*100).toFixed(2));
        }

//        $("#level1-chart-container").css({"height" : (yAxisData.length * 2) + "rem"});

        let label = {
          normal: {
            show: true,
            position: 'inside',
            formatter: function (params) {
              return params.value <= 0 ? '' : (params.value);
            }
          }
        };

        let seriesData = [
          {
            name: '男',
            type: 'bar',
            stack: '总量',
            label: label,
            itemStyle : {
              color : "#4F81BD"
            },
            data: manCntList
          },
          {
            name: '女',
            type: 'bar',
            stack: '总量',
            label: label,
            itemStyle : {
              color : "#C0504D"
            },
            data: womanCntList
          }
        ];

        let chartOption = {

          tooltip : {
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
//            formatter: '{b}<br/>{a0}: {c0}%<br/>{a1}: {c1}%'
          },
          color : this.chartColor,
          legend: {
            data: legendData
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis:  {
            type: 'value'
          },
          yAxis: {
            type: 'category',
            data: yAxisData
          },
          series: seriesData
        };

        this.getLevel1ChartDom().setOption(chartOption);
      },

      /**
       * 客户性别统计表
       */
      queryCustSexCnt(){
        this.$api.get("api/custReport/report4CustGender",{
          dealerId : this.queryParams.deptId,
          salesId : this.$wxuserUtil.getUserId(),
          startDate : this.queryParams.startDate,
          endDate : this.queryParams.endDate
        }).then(response => {
          if(response.success){
            //绘制条形图
            this.drawCustSexLine(response.data || []);

            //绘制表格
            this.tableData.custGender = response.data || [];
          }else{
            this.$toast(response.msg || `报表数据查询失败`);
          }
        });
      },

      /**
       * 查询报表数据
       */
      queryReportData(){
        if(!this.queryParams.deptId){
          this.$toast("请选择门店");
          return ;
        }
        this.clearData();
        switch (this.queryParams.reportType){
          case this.reportTypeMap.prodOneTwoSale://产品一级二级分类销售统计表
            this.queryProdOneTwoSale();
            break;
          case this.reportTypeMap.prodTwoSortAmount://产品二级分类销售金额统计表
            this.queryProdTwoSortAmount();
            break;
          case this.reportTypeMap.prodOneSortAmount://产品一级分类销售金额统计表
            this.queryProdOneSortAmount();
            break;
          case this.reportTypeMap.custBelongCityCnt://客户所在城市分布人数统计表
            this.queryCustBelongCityCnt();
            break;
          case this.reportTypeMap.custInterestSortCnt://客户兴趣爱好分类统计表
            this.queryCustInterestSortCnt();
            break;
          case this.reportTypeMap.custPhotography://客户摄影主题分类统计表
            this.queryCustPhotography();
            break;
          case this.reportTypeMap.custAttendSortCnt://客户意向课程分类统计表
            this.queryCustAttendSortCnt();
            break;
          case this.reportTypeMap.custSexCnt://客户性别统计表
            this.queryCustSexCnt();
            break;
          default :
            break;
        }
      },

      /**
       * 查询报表类型
       */
      queryReportType(){
        this.$api.getQueryByTcode({"tcode" : this.$wxuserUtil.dictKey.ReportType}).then(response =>{
          if(response.success){
            let data = response.data || [];
            if(data.length > 0){
              this.reportTypeList = data;

              this.queryParams.reportType = data[0].value;
              this.queryParams.reportTypeName = data[0].name;
            }
          }
        });
      },

      /**
       * 报表类型选择确认
       */
      reportTypeChange(e){
        this.queryParams.reportType = e.value;
        this.queryParams.reportTypeName = e.name;
        this.showReportType = !this.showReportType;
      },
      /**
       * 查询部门
       */
      queryDept(){
        if(!this.queryParams.deptArea){
          return;
        }
        this.$api.getDealerlist({
          salesId : this.$wxuserUtil.getUserId(),
          area : this.queryParams.deptArea
        }).then(response => {
          if(response.success){
            this.deptList = [{
              deptName:'请选择门店',
              deptId:''
            },...(response.data || [])];

            for(let i=0;i<this.deptList.length;i++){
              let deptObj = this.deptList[i];
              if(deptObj.deptId == this.$wxuserUtil.getDeptId()){
                this.queryParams.deptId = deptObj.deptId;
                this.queryParams.deptName = deptObj.deptName;
                break;
              }
            }
          }
        });
      },

      /**
       * 部门选择确认
       */
      deptChange(e){
        this.queryParams.deptId = e.deptId;
        this.queryParams.deptName = e.deptName;
        this.showDeptPop = !this.showDeptPop;
      },

      /**
       * 查询部门区域
       */
      queryDeptArea(){
        this.$api.getQueryByTcode({"tcode" : this.$wxuserUtil.dictKey.AREA}).then(response =>{
          if(response.success){
            this.deptAreaList.push(...(response.data ||[]));

            for(let i=0;i<this.deptAreaList.length;i++){
              let deptAreaObj = this.deptAreaList[i];
              if(deptAreaObj.value == this.$wxuserUtil.getDeptArea()){
                if(this.$wxuserUtil.isRoleShopManager()){
                  this.deptAreaList = [deptAreaObj];
                }

                this.queryParams.deptArea = deptAreaObj.value;
                this.queryParams.deptAreaName = deptAreaObj.name;
                this.queryDept();
                break;
              }
            }
          }
        });
      },

      /**
       * 区域选择确认
       * @param e
       */
      deptAreaChange(e){
        this.queryParams.deptArea = e.value;
        this.queryParams.deptAreaName = e.name;
        this.showDeptAreaPop = !this.showDeptAreaPop;
        this.deptList = [
          {
            deptName:'请选择门店',
            deptId:''
          }
        ];
        this.queryParams.deptId = "";
        this.queryParams.deptName = "";

        this.queryDept();
      },

      /**
       * 选择开始日期
       */
      getFirstDate(e){
        var currentDate = e.getTime();
        /*if(this.queryParams.endDateTS && currentDate > this.queryParams.endDateTS){
          this.$title('活动开始时间不可早于结束时间')
          return
        }*/
        this.showDateTime1=!this.showDateTime1
        this.queryParams.startDateTS = currentDate;
        this.queryParams.startDate =moment(e).format('YYYY-MM-DD')
      },

      /**
       * 选择结束日期
       */
      getEndDate(e){
        var currentDate = e.getTime();
        /*if(this.queryParams.endDateTS && currentDate > this.queryParams.endDateTS){
          this.$title('活动开始时间不可早于结束时间')
          return
        }*/
        this.showDateTime2=!this.showDateTime2
        this.queryParams.endDateTS = currentDate;
        this.queryParams.endDate =moment(e).format('YYYY-MM-DD')
      }
    },
    mounted(){
      this.queryDeptArea();
      this.queryReportType();
    }
  };
</script>


<style lang="less" src="~p/pageView-resportList.less"></style>
<style lang="less">
  .triangle_border_down{
    position: relative;
    top:8px;
  }

  #level1-chart-container,#level2-chart-container{
    width: 100%;
    min-height: 6rem;
    overflow-y: auto;
  }
  /*#level2-chart-container{
    width: 100%;
    min-height: 6rem;
    overflow-y: auto;
  }*/

  .div-query-area{
    background: #fff !important;
    padding: 0 0.3rem 0.2rem;
    border-bottom: 0.05rem solid #ccc;
  }
  .div-query-area .van-col{
    text-align: center;
  }

  .div-query-area button{
    width: 80%;
  }

  .picker-report-choose{
    display: block;
    justify-content: flex-end !important;
    padding-bottom: 0.2rem !important;
    padding-top: 0.2rem !important;
    border-bottom: 0.05rem solid #ccc;
  }

  .div-query-form{
    border-bottom: 0.05rem solid #ccc;
    padding-bottom: 0.2rem !important;
  }

  .picker-report-choose .picker-alls{
    float: right;
    flex:0.6 !important;
  }

  .panel-report-chart{
    width: 100%;
    min-height: 2rem;
    background: #fff !important;
    margin-bottom: 0.1rem;
    overflow: auto;
  }

  .table-report{
    min-width: 100%;
    overflow: auto;
    border-collapse: collapse;
  }

  .table-report th,.table-report td:first-child{
    background: #F2F2F2;
    text-align: left;
  }

  .table-report th,.table-report td{
    border: 1px solid #ABABAB;
    height: 40px;
    text-align: center;
    min-width: 2rem;
    padding: 0 0.2rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/reports/report4SalesAnalysis.vue